import { PhilosophyPrinciple, AnimeQuote } from '../types';

/**
 * The Weeb Manifesto
 */
export const weebManifesto: PhilosophyPrinciple[] = [
  {
    number: 1,
    title: 'Everything Here Is Free',
    description: 'Not GPL. Not MIT. Not even copyleft. Public. Domain. Baby.',
    expanded: [
      'When we say free, we mean FREE free.',
      'No licenses. No restrictions. No strings attached.',
      'Take it. Fork it. Sell it. We don\'t care.',
      'This is chaos. This is freedom.',
      'This is the way.'
    ]
  },
  {
    number: 2,
    title: 'Always Go Full Weeb',
    description: 'No half-measures. No compromises. Full commitment to the bit.',
    expanded: [
      'If you\'re gonna do something, go all the way.',
      'Normal people would make a simple README. We write a comedy routine.',
      'Normal people would make a basic website. We make 5 secret themes.',
      'Normal people would stop. We never stop.',
      'This is the weeb way.'
    ]
  },
  {
    number: 3,
    title: 'Over-Engineering Is A Feature',
    description: 'If it\'s worth doing, it\'s worth overdoing spectacularly.',
    expanded: [
      'Why make something simple when you can make it complex?',
      'Why use one theme when you can have five?',
      'Why write normal documentation when you can write performance art?',
      'Is it necessary? No. Is it awesome? Also no. Did we do it anyway? Yes.',
      'More over-engineered than a Gundam. Less practical too.'
    ]
  },
  {
    number: 4,
    title: 'Self-Awareness Is Mandatory',
    description: 'Know how ridiculous this is. Embrace it. Make it part of the brand.',
    expanded: [
      'Yes, we made a whole website for one project.',
      'Yes, we spent a year and a half putting commercials back into anime.',
      'Yes, this is absurd.',
      'We know. We were there. We did it anyway.',
      'Self-awareness is the path to enlightenment. Or comedy. Probably comedy.'
    ]
  }
];

/**
 * Coding Philosophy (adapted from coding-philosophy.md)
 * Made weebier for the website
 */
export const codingPhilosophy = {
  title: 'How We Actually Code',
  subtitle: '(When we\'re not making weeb jokes)',
  principles: [
    {
      title: 'Defensive Engineering (AKA Expect Failure)',
      description: 'Like a battle-hardened shonen protagonist, we assume everything will eventually break.',
      points: [
        'Networks drop like Vegeta\'s pride',
        'Disks fill faster than a tournament arc',
        'Users click buttons in unexpected orders (why are you like this?)',
        'When something fails, the error should tell you exactly what, where, why, and how to fix it',
        'Fail fast, fail clear, fail with dignity'
      ]
    },
    {
      title: 'Single Source of Truth (One Hokage, One Orchestrator)',
      description: 'Just like a village needs one Hokage, your app needs one source of truth.',
      points: [
        'Create one class that owns all state',
        'All interfaces (GUI, web, CLI) use the same orchestrator',
        'No duplicated logic, no divergent state',
        'Fix a bug once, it\'s fixed everywhere',
        'This is the way of the ninja'
      ]
    },
    {
      title: 'DRY Obsessively (Don\'t Repeat Yourself)',
      description: 'If you see the same code twice, you\'ve already failed. Extract it. Centralize it. Never speak of this shame again.',
      points: [
        'Hunt down duplication like you\'re hunting for the One Piece',
        'If it appears twice, make it a utility',
        'Consistency across the codebase or death',
        'Well, not death. But we\'ll judge you.'
      ]
    },
    {
      title: 'Users Deserve Transparency (No "Trust Me Bro" Energy)',
      description: 'Tell users what\'s happening. Always. No fake progress bars. No lies.',
      points: [
        'Broadcast status at every step',
        'Real progress based on real work',
        'Never say "Done" when there were errors',
        'The status bar never lies',
        'Respect your users like you respect your waifu'
      ]
    },
    {
      title: 'Thread Everything (Never Block the Main Thread)',
      description: 'Long operations run in background threads. The UI must never freeze. This is non-negotiable.',
      points: [
        'Design for threads from day one',
        'All shared utilities must be thread-safe',
        'Blocking the main thread is how you get "Application Not Responding"',
        'And angry users. Very angry users.'
      ]
    }
  ]
};

/**
 * Anime quotes for footer rotation
 */
export const animeQuotes: AnimeQuote[] = [
  { quote: 'Stay gold.', character: 'TOM', anime: 'Toonami' },
  { quote: 'El. Psy. Kongroo.', character: 'Okabe Rintarou', anime: 'Steins;Gate' },
  { quote: 'Believe it!', character: 'Naruto', anime: 'Naruto' },
  { quote: 'I\'m going to be the Pirate King!', character: 'Luffy', anime: 'One Piece' },
  { quote: 'See you space cowboy...', character: 'Credits', anime: 'Cowboy Bebop' },
  { quote: 'People die when they are killed.', character: 'Shirou', anime: 'Fate/stay night' },
  { quote: 'Just who the hell do you think I am?!', character: 'Kamina', anime: 'Gurren Lagann' },
  { quote: 'I\'ll take a potato chip... and eat it!', character: 'Light', anime: 'Death Note' },
  { quote: 'It\'s a terrible day for rain.', character: 'Roy Mustang', anime: 'FMA: Brotherhood' },
  { quote: 'This... is my Bankai.', character: 'Ichigo', anime: 'Bleach' }
];
